/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WebsitImageConfigInfoRespVo } from './WebsitImageConfigInfoRespVo';
import {
    WebsitImageConfigInfoRespVoFromJSON,
    WebsitImageConfigInfoRespVoFromJSONTyped,
    WebsitImageConfigInfoRespVoToJSON,
    WebsitImageConfigInfoRespVoToJSONTyped,
} from './WebsitImageConfigInfoRespVo';

/**
 * 
 * @export
 * @interface ResponseWebsitImageConfigInfoRespVo
 */
export interface ResponseWebsitImageConfigInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseWebsitImageConfigInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseWebsitImageConfigInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {WebsitImageConfigInfoRespVo}
     * @memberof ResponseWebsitImageConfigInfoRespVo
     */
    data?: WebsitImageConfigInfoRespVo;
}

/**
 * Check if a given object implements the ResponseWebsitImageConfigInfoRespVo interface.
 */
export function instanceOfResponseWebsitImageConfigInfoRespVo(value: object): value is ResponseWebsitImageConfigInfoRespVo {
    return true;
}

export function ResponseWebsitImageConfigInfoRespVoFromJSON(json: any): ResponseWebsitImageConfigInfoRespVo {
    return ResponseWebsitImageConfigInfoRespVoFromJSONTyped(json, false);
}

export function ResponseWebsitImageConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseWebsitImageConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : WebsitImageConfigInfoRespVoFromJSON(json['data']),
    };
}

export function ResponseWebsitImageConfigInfoRespVoToJSON(json: any): ResponseWebsitImageConfigInfoRespVo {
    return ResponseWebsitImageConfigInfoRespVoToJSONTyped(json, false);
}

export function ResponseWebsitImageConfigInfoRespVoToJSONTyped(value?: ResponseWebsitImageConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': WebsitImageConfigInfoRespVoToJSON(value['data']),
    };
}

